import * as Sentry from '@sentry/react';
import { authKeys } from '@arc/frontend/util-auth';
import { sentryPleaseIgnoreThis, sharedSentryOptions } from '@arc/shared/util-sentry';
import { queryClient } from './queryClient';
function isNotLoggedIn() {
  return queryClient.getQueryData(authKeys.session()) === null;
}
Sentry.init({
  ...sharedSentryOptions,
  dsn: process.env.NX_PUBLIC_SENTRY_DSN_FRONTEND,
  integrations: [Sentry.browserTracingIntegration(), Sentry.captureConsoleIntegration({
    levels: ['error']
  }), Sentry.replayIntegration({
    maskAllText: false,
    maskAllInputs: false,
    blockAllMedia: false
  })],
  // Capture no session replays...
  replaysSessionSampleRate: 0,
  // ...unless an error occurs
  replaysOnErrorSampleRate: 1,
  ignoreErrors: ["Can't perform a React state update on an unmounted component.", 'status code 400', 'status code 401', '401 (Unauthorized)', 'status code 403', '403 (Forbidden)', 'ResizeObserver loop limit exceeded', 'LaunchDarkly', 'Logged out', 'The above error occurred in the', 'no-response', 'AbortError'],
  beforeSend: (event, hint) => {
    const error = hint.originalException;
    if (error?.[sentryPleaseIgnoreThis] || isNotLoggedIn()) {
      return null;
    }
    return event;
  }
});